<template>
  <div class="box-1">
    <div class="text-center">
      <div class="img-info">
        <div class="d-flex justify-content-between">
          <b style="font-size: 14px"> Нэмэгдүүлсэн ХА: </b>
          <b style="font-size: 14px">
            {{ this.last2yearPurchase | pricewithindex }} ₮
          </b>
        </div>
        <div class="d-flex justify-content-between">
          <b style="font-size: 14px"> Сүүлийн 2 жилийн ХА: </b>
          <b style="font-size: 14px"
            >{{ this.oldPurchaseAmount | pricewithindex }} ₮
          </b>
        </div>
        <br />
        <span
          >Дараагийн хувь хүрэхэд <br /><b>{{ this.amount }} ₮</b></span
        >
        <p>худалдан авалт дутуу</p>
      </div>
    </div>
    <div class="row">
      <div class="col-md-6 text-left">
        <p v-if="currentPercent < 10">{{ this.currentPercent }} %</p>
      </div>
      <div class="col-md-6 text-right">
        <p>{{ this.nextPercent }} %</p>
      </div>
    </div>
    <div class="prog">
      <span v-bind:class="this.widthPercent"></span>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      currentPercent: 0,
      nextPercent: 0,
      amount: 0,
      widthPercent: "",
      last2yearPurchase: 0,
      oldPurchaseAmount: 0,
    };
  },
  methods: {
    getNextAmount() {
      var tokenId = localStorage.getItem("authToken");
      var user = this.$auth.getMe();
      if (tokenId == null || user == null) {
        this.$auth.destroyToken();
        this.$auth.removeMe();
        this.$router.push({ name: "login" });
      }
      var cardHolderInfId = user.cardHolderInfId;
      // this.$axiosApi
      this.$bonusApi
        .post(
          `bonus-card/info/token`,
          // `card/info`,
          { tokenId },
          {
            headers: {
              "Content-Type": "application/json",
              "Accept-Language": "mn",
            },
          }
        )
        .then((response) => {
          var results = response.data;
          if (results.status === 0) {
            this.currentPercent = results.cardPercent;
            if (results.cardPercent === 9 || results.cardPercent === 10) {
              this.nextPercent = 10;
            } else {
              this.nextPercent = this.currentPercent + 1;
            }
            this.last2yearPurchase = results.last2yearPurchase;
            this.oldPurchaseAmount = results.oldPurchaseAmount;
          } else {
            this.balanceAmount = 0;
          }
        })
        .catch(() => {
          this.$auth.destroyToken();
          this.$auth.removeMe();
          this.$router.push({ name: "login" });
        });
      this.$bonusApi
        // this.$axiosApi
        .post(
          // `card/next`,
          `bonus-card/next`,
          { tokenId, cardHolderInfId },
          {
            headers: {
              "Accept-Language": "mn-MN",
              "Content-Type": "application/json",
              "Access-Control-Allow-Origin": "*",
            },
          }
        )
        .then((response) => {
          var data = response.data;
          if (response.data.status === 0) {
            this.widthPercent = data.nextPercent;
            this.amount = new Intl.NumberFormat().format(
              Math.floor(data.nextPercentAmount)
            );
          }
        })
        .catch(() => {});
    },
  },
  created() {
    this.getNextAmount();
  },
};
</script>
